import {Check} from '@sparkware/app-utils';

export class Lazy<T>{
  constructor(private _valueFactory: () => T) {
  }

  private _value = undefined;

  private _initValue() {
    if(Check.isUndefined(this._value)) {
      this._value = this._valueFactory();
    }
  }

  get value(): T {
    this._initValue();

    return this._value;
  }

  forceInit() {
    this._initValue();
  }
}
